var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app",
      class: { "app--full-height": _vm.$route.meta.isFullHeight }
    },
    [
      _c("notifications", { attrs: { duration: 5000 } }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { size: "large", open: _vm.isLegalModalOpen },
          on: { close: _vm.closeModal }
        },
        [_c("legal", { attrs: { "is-primary": _vm.isPrimaryLegal } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            size: "large",
            open: _vm.isPartnerLegalModalOpen,
            heading: "Vivid Seats Offer Terms"
          },
          on: { close: _vm.closeModal }
        },
        [_c("p", { domProps: { innerHTML: _vm._s(_vm.$config.partnerLegal) } })]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "quebec-user-modal",
          attrs: {
            size: "large",
            open: _vm.isQuebecUserModalOpen || _vm.isQuebecUserCheckoutModalOpen
          },
          on: { close: _vm.closeModal }
        },
        [
          _vm.isQuebecUserModalOpen
            ? _c("h1", { staticClass: "quebec-user-modal__heading" }, [
                _vm._v("Québec Resident?")
              ])
            : _c("h1", { staticClass: "quebec-user-modal__heading" }, [
                _vm._v("We are unable to process your order.")
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "quebec-user-modal__content" }, [
            _vm._v(
              "Unfortunately, due to circumstances outside our control, we are not currently able to meet the needs of shoppers in Québec. If you are a resident of Québec, you will not be able to purchase tickets at this time. Thank you for your understanding!"
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "quebec-user-modal__button",
              on: { click: _vm.closeModal }
            },
            [_vm._v("Got it")]
          )
        ]
      ),
      _vm._v(" "),
      _vm.bulletin && _vm.bulletin.legal
        ? _c(
            "modal",
            {
              attrs: { size: "large", open: _vm.isBulletinLegalOpen },
              on: { close: _vm.closeModal }
            },
            [_c("p", { domProps: { innerHTML: _vm._s(_vm.bulletin.legal) } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "app__login-modal",
          attrs: { open: _vm.isLoginModalOpen },
          on: { close: _vm.closeModal }
        },
        [
          _c(
            "login-form",
            {
              staticClass: "app__login-form",
              attrs: {
                "username-placeholder": "Account ID",
                "on-valid-submit": _vm.login,
                "username-initial-value":
                  (_vm.$config.auth || {}).loginUsernameDefault || ""
              }
            },
            [
              _c("div", { attrs: { slot: "intro" }, slot: "intro" }, [
                _c("p", { staticClass: "app__login-intro" }, [
                  _vm._v("Please enter your Account ID and password below.")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { size: "large", open: _vm.isWarningModalOpen },
          on: { close: _vm.closeModal }
        },
        [_c("warning")],
        1
      ),
      _vm._v(" "),
      _c(
        "pageHeader",
        {
          staticClass: "app__header",
          attrs: {
            bulletin: _vm.bulletin,
            disclaimer: _vm.disclaimer,
            event: _vm.$store.state.event,
            "has-big-search": _vm.$route.meta.hasBigHeaderSearch,
            "has-logo-tab": _vm.hasLogoTab,
            "has-logout": Boolean(
              _vm.$config.auth && _vm.$config.auth.hasLogout
            ),
            "has-my-account-button": Boolean(
              _vm.$config.auth && _vm.$config.auth.isConcierge
            ),
            "has-my-tickets-button": Boolean(
              _vm.$config.auth && _vm.$config.auth.hasMyTicketsButton
            ),
            highlights: _vm.highlights,
            highlightedSuggestion: _vm.highlightedSuggestion,
            "is-fluid": _vm.$route.meta.hasFluidHeader,
            "is-show-bulletin": _vm.$route.meta.hasBulletin,
            "is-show-menu": _vm.$route.meta.hasHeaderMenu,
            "is-show-page-not-found": _vm.isNotFoundPage,
            "is-show-partner-banner": _vm.$route.meta.hasPartnerBanner,
            "is-show-search": _vm.$route.meta.hasHeaderSearch,
            "is-tall": _vm.$route.meta.hasTallHeader,
            "logo-desktop": _vm.logoDesktop,
            "logo-mobile": _vm.logoMobile,
            "make-entity-route": _vm.makeEntityRoute,
            "on-decrement-highlighted-suggestion-index":
              _vm.decrementHighlightedSuggestionIndex,
            "on-increment-highlighted-suggestion-index":
              _vm.incrementHighlightedSuggestionIndex,
            "on-search": _vm.onSearch,
            "on-search-input-change": _vm.onSearchInputChange,
            "on-set-active-category": _vm.onSetActiveCategory,
            "on-suggestion-click": _vm.onSuggestionClick,
            "partner-logo-desktop": _vm.partnerLogoDesktop,
            "partner-logo-mobile": _vm.partnerLogoMobile,
            query: _vm.query,
            suggestions: _vm.suggestions,
            userProfile: _vm.$store.state.userProfile
          },
          on: { "clear-search-query": _vm.onClearSearchQuery }
        },
        [
          _vm.$store.state.loyalty && _vm.$store.state.userProfile
            ? _c(
                "span",
                {
                  staticClass: "app__welcome",
                  attrs: { slot: "welcome" },
                  slot: "welcome"
                },
                [
                  _vm._v(
                    "\n            Welcome, " +
                      _vm._s(_vm.$store.state.userProfile.first_name) +
                      "\n            "
                  ),
                  _c("span", { staticClass: "welcome__user-info" }, [
                    _vm.creditCardType && _vm.lastFour
                      ? _c("span", { staticClass: "user-info__credit-card" }, [
                          _vm.creditCardType
                            ? _c("img", {
                                staticClass: "user-info__credit-card__icon",
                                attrs: {
                                  alt: _vm.creditCardType.displayName,
                                  src:
                                    _vm.$store.state.imagesCdn +
                                    _vm.creditCardType.iconSlug
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "user-info__middot" }, [
                            _vm._v("····")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "user-info__last-four" }, [
                            _vm._v(_vm._s(_vm.lastFour))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "user-info__pipe" }, [
                            _vm._v("|")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "user-info__loyalty-balance" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatPoints(_vm.$store.state.loyalty.balance)
                        ) + " "
                      ),
                      _vm.$store.state.loyalty.program_display_name &&
                      !_vm.$config.hideLoyaltyProgramName
                        ? _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.$store.state.loyalty.program_display_name
                                ) +
                                ")"
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.state.loyalty && _vm.$store.state.userProfile
            ? _c(
                "span",
                {
                  staticClass: "app__welcome app__welcome--mobile",
                  attrs: { slot: "welcome-mobile" },
                  slot: "welcome-mobile"
                },
                [
                  _vm.creditCardType && _vm.lastFour
                    ? _c(
                        "span",
                        { staticClass: "welcome__user-info user-info-mobile" },
                        [
                          _c(
                            "span",
                            { staticClass: "user-info__credit-card" },
                            [
                              _vm.creditCardType
                                ? _c("img", {
                                    staticClass: "user-info__credit-card__icon",
                                    attrs: {
                                      alt: _vm.creditCardType.displayName,
                                      src:
                                        _vm.$store.state.imagesCdn +
                                        _vm.creditCardType.iconSlug
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "user-info__middot" }, [
                                _vm._v("····")
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "user-info__last-four" },
                                [_vm._v(_vm._s(_vm.lastFour))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "user-info__loyalty-balance" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPoints(
                                    _vm.$store.state.loyalty.balance
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _c("span", {
                        staticClass:
                          "icon--large icon-profile fx-hidden--large fx-hidden--full"
                      })
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app__main",
          class: { "app__main--not-found": _vm.isNotFoundPage }
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            attrs: { setDisclaimer: _vm.setDisclaimer }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasFooter
        ? _c("footer", [
            _c("div", { staticClass: "footer__inner" }, [
              _vm.$config.hasCustomFooterLogo
                ? _c("img", {
                    staticClass: "footer__custom-logo",
                    attrs: { alt: _vm.logoFooter.alt, src: _vm.logoFooter.url }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$config.hasPoweredByVividSeats
                ? _c("img", {
                    staticClass: "footer__logo",
                    attrs: {
                      alt: "Vivid Seats logo",
                      src: _vm.$store.state.imagesCdn + "/powered_by_VS_V2.svg"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.meta.hasFooterNav
                ? _c("nav", { staticClass: "footer__nav" }, [
                    _c("ul", { staticClass: "footer__nav-list" }, [
                      _c(
                        "li",
                        { staticClass: "footer__nav-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "footer__nav-link",
                              attrs: { to: { name: "help" } },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.onClickHelp($event)
                                }
                              }
                            },
                            [_vm._v("Help")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "footer__nav-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "footer__nav-button",
                              attrs: {
                                to: {
                                  query: _vm.updateQueryParams(
                                    _vm.$route.query,
                                    { modal: "legal" }
                                  )
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.onClickLegal($event)
                                }
                              }
                            },
                            [_vm._v("Legal")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "footer__nav-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "footer__nav-button",
                              attrs: { to: { name: "privacy" } },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.onClickPrivacy($event)
                                }
                              }
                            },
                            [_vm._v("Privacy")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }